export type {
  CastaiNotificationsV1beta1Notification as Notification,
  CastaiNotificationsV1beta1WebhookConfig as Webhook,
  CastaiNotificationsV1beta1SlackConfig as SlackConfiguration,
  CastaiNotificationsV1beta1ListSlackConfigsResponse as ListSlackConfigurationsResponse,
  CastaiNotificationsV1beta1ListSlackWorkspacesResponse as ListSlackWorkspacesResponse,
  CastaiNotificationsV1beta1AddSlackConfig as CreateSlackConfiguration,
  CastaiNotificationsV1beta1UpdateSlackConfig as UpdateSlackConfiguration,
  CastaiNotificationsV1beta1AddWebhookConfig as CreateWebhook,
  CastaiNotificationsV1beta1UpdateWebhookConfig as UpdateWebhook,
  CastaiNotificationsV1beta1ListNotificationsResponse as NotificationsListResponse,
  CastaiNotificationsV1beta1ListWebhookConfigsResponse as WebhooksListResponse,
  NotificationAPIApiNotificationAPIListNotificationsRequest as ListNotificationsRequest,
  CastaiNotificationsV1beta1CreateSlackWorkspaceInstallResponse as InstallSlackWorkspaceResponse,
  CastaiNotificationsV1beta1ListSlackChannelsResponse as ListSlackChannelsResponse,
  CastaiNotificationsV1beta1Definition as NotificationDefinition,
  CastaiNotificationsV1beta1SlackWorkspace as SlackWorkspaceData,
} from '@cast/openapi';

export { CastaiNotificationsV1beta1Severity as NotificationSeverity } from '@cast/openapi';

export enum WebhookStatus {
  CONNECTED = 'CanConnect',
  FAILED = 'FailedToConnect',
}

export enum SlackStatus {
  OK = 'OK',
  DEGRADED = 'Degraded',
  NOT_OK = 'NotOK',
  UNKNOWN = 'Unknown',
}

export enum DeliveryMethod {
  Slack = 'slack',
  Webhook = 'webhook',
}
